/**
 * Search actions for the EB search
 *
 */
export const EB_SEARCH_REQUEST_STARTED = 'EB_SEARCH_REQUEST_STARTED';
export function ebSearchRequestStarted() {
  return {
    type: EB_SEARCH_REQUEST_STARTED,
    isFetchingEb: true,
  };
}

export const EB_SEARCH_REQUEST_COMPLETED = 'REQUEST_COMPLETED';
export function ebSearchRequestStopped() {
  return {
    type: EB_SEARCH_REQUEST_COMPLETED,
    isFetchingEb: false,
  };
}

export const EB_SEARCH_CRITERIA_SPECIFIED = 'EB_SEARCH_CRITERIA_SPECIFIED';
export function ebSearchCriteriaSpecified(critera) {
  return {
    type: EB_SEARCH_CRITERIA_SPECIFIED,
    searchCriteria: critera,
  };
}

export const EB_ENTITIES_FETCHED = 'EB_ENTITIES_FETCHED';
export function ebEntitiesFetched(entities) {
  return {
    type: EB_ENTITIES_FETCHED,
    entities: entities,
  };
}

/**
 * Reset search criteria to default state
 */
export const EB_CLEAR_SEARCH = 'EB_CLEAR_SEARCH';
export function ebClearSearch() {
  return {
    type: EB_CLEAR_SEARCH,
  };
}

export const RESET_CURRENT_SAVED_SEARCH = 'RESET_CURRENT_SAVED_SEARCH';
export function requestResetCurrentSavedSearch() {
  return {
    type: RESET_CURRENT_SAVED_SEARCH,
  };
}

export const USER_SAVED_SEARCH_EDIT = 'USER_SAVED_SEARCH_EDIT';
export function userSavedSearchEdit(savedSearch) {
  return {
    type: USER_SAVED_SEARCH_EDIT,
    savedSearch: savedSearch,
  };
}

export const USER_SAVED_SEARCH_EDIT_VIEW = 'USER_SAVED_SEARCH_EDIT_VIEW';
export function userSavedSearchEditView(view) {
  return {
    type: USER_SAVED_SEARCH_EDIT_VIEW,
    view: view,
  };
}

/**
 * Action to update the dirty/clean status of the current saved search
 */
export const USER_SAVED_SEARCH_DIRTY = 'USER_SAVED_SEARCH_DIRTY';
export function userSavedSearchDirty(dirtyFlag) {
  return {
    type: USER_SAVED_SEARCH_DIRTY,
    dirtyFlag: dirtyFlag,
  };
}
